export default class Drag {
  plate = null;
  plateObj = null;
  blockStyle = {}
  maxNum
  blockMap = new Map();
  curBlock = {};
  fn;

  /**
   * 
   *   @param {String} plate: 区域類名(.question-design) || body
   *   @param {Object} blockStyle 
   *    style: 方块样式,
   *    selectStyle: 方块选中样式
   *   @param {number | string} maxNum: 允许最多方块 默认10
   *    
   */
  constructor({plate, blockStyle, maxNum}) {
    this.plate = document.querySelector(plate) || document.body
    this.plate.style.position = 'relative'

    this.plateObj = {
      width: this.plate.offsetWidth,
      height: this.plate.offsetHeight,
      plateClass: plate
    }
    this.submitOffset()
    this.blockStyle = blockStyle
    this.maxNum = maxNum || 10
  }

  submitOffset() {
    let {left, top} = this.getNodeOffset(this.plate)

    this.plateObj.left = left
    this.plateObj.top = top
  }

  /**
   * 创建 方块
   * @param {*} callback 
   *      函數回调
   * @param {*} blockType 
   *      创建方块類型 (矩形，圆形)
   * @param {*} style 
   *      创建自带样式 
   * @param {*} info 
   *      创建自带方块属性 
   * @returns 
   */  
  createBlock(callback, blockType = '', style = '', info = null) {
    // 当前 方块 的數量
    let curBlockNumber = document.querySelectorAll(`${this.plateObj.plateClass} .${this.blockStyle.style}`).length,
    uuid = this.getUuid()

    // 最大限制
    if(curBlockNumber >= this.maxNum) return ;

    this.removeSelectBlock()

    // 录入數据
    let blockInfo = info || JSON.parse(JSON.stringify(this.blockInfo))
    blockInfo.blockType = blockType
    blockInfo.style = style
    blockInfo.uuid = uuid
    this.blockMap.set(uuid, blockInfo)
    this.curBlock = blockInfo

    // 创建节点
    let block = document.createElement('div')
    block.setAttribute('class', `${ this.blockStyle.style } ${blockInfo.style} ${this.blockStyle.selectStyle}`)
    block.setAttribute('id', uuid)
    block.style =  `
      zIndex: ${++curBlockNumber};
      width: ${blockInfo.width}px;
      height: ${blockInfo.height}px;
      left: ${blockInfo.x}px;
      top: ${blockInfo.y}px;
      background-image: url(${blockInfo.image});
      background-color: ${blockInfo.opaqueBottom ? '#ccc' : 'rgba(0, 0, 0, 0)'}
    `
    this.plate.append(block)

    this.blockCreateEvent(block)
    this.blockAddDrag(block)

    callback(block)

    this.fn(this.blockMap)
  }

  /**
   * 方块节点添加 事件
   * @param {*} node 
   */
  blockCreateEvent(node) {
    let { plate, blockMap, plateObj } = this
    
    // 点击触发
    node.addEventListener('mousedown', ev => {
      // 阻止事件冒泡
      let event = ev || window.event
      event.stopPropagation()

      let bLayerX = ev.layerX, bLayerY = ev.layerY,
      nodeMap = blockMap.get(node.id)

      this.removeSelectBlock()
      
      // 给当前方块添加 选中样式
      let uuid = node.id
      
      if(!this.curBlock.uuid) {
        this.curBlock = this.blockMap.get(uuid)
        node.classList.add(this.blockStyle.selectStyle)
      }

      plate.onmousemove = e => {
        let {pageX, pageY} = e,
        differX = pageX - bLayerX - plateObj.left, 
        differY = pageY - bLayerY - plateObj.top
        
        nodeMap.x = differX
        nodeMap.y = differY

        // 限制可移动区域 
        if(differX < 0) nodeMap.x = 0
        else if(differX > (plateObj.width - nodeMap.width)) nodeMap.x = plateObj.width - nodeMap.width
        if(differY < 0) nodeMap.y = 0
        else if(differY > (plateObj.height - nodeMap.height)) nodeMap.y = plateObj.height - nodeMap.height

        // 更新左下坐标
        nodeMap.rightBottomCoordinate = {
          x: nodeMap.x + nodeMap.width,
          y: nodeMap.y + nodeMap.height,
        }

        // 更新视图
        node.style.left = nodeMap.x + 'px'
        node.style.top = nodeMap.y + 'px'

        this.fn(this.blockMap)
      }
    })
    
    // 鼠标抬起
    node.addEventListener('mouseup', () => {
      plate.onmousemove = null
    })

    // ---------- 在派生類中定义
    // 右键触发 
    // node.addEventListener('contextmenu', ev => {
    //   ev.preventDefault()

    //   let { rightKeyMenu } = this
    //   rightKeyMenu.style.display = 'block'
    //   rightKeyMenu.style.left = `${ev.pageX}px`
    //   rightKeyMenu.style.top = `${ev.pageY}px`
    //   rightKeyMenu.focus()
      
    //   for(let i = 0; i < rightKeyMenu.childNodes.length; i++) {
    //     let item = rightKeyMenu.childNodes[i]

    //     if([...item.classList].indexOf('mislead-choice') > -1) {
    //       item.innerText = this.curBlock.mislead ? '取消误导选项' : '设为误导选项'
    //     }
    //     if([...item.classList].indexOf('opaque-bottom') > -1) {
    //       item.innerText = this.curBlock.opaqueBottom ? '设置为透明底层' : '设置为不透明底层' 
    //       break ;
    //     }
    //   }
    // })
  }

  /**
   * 方块 添加拖拽点
   * @param {*} node 
   *    需要添加的节点
   */
  blockAddDrag(node) {
    let dragList = ['leftTop', 'top', 'rightTop', 'right', 'rightBottom', 'bottom', 'leftBottom', 'left']
    // console.log(node)
    while(node.childNodes.length < dragList.length) {
      let nodesLeng = node.childNodes.length,
      drag = document.createElement('div')
      drag.setAttribute('class', `drag ${dragList[nodesLeng]}`)
      node.append(drag)
      this.dragCreateEvents(drag, dragList[nodesLeng])
    }
  }

  /**
   * 拖拽点创建事件
   * @param {*} dNode 
   * @param {String} dragPosition 'leftTop', 'top', 'rightTop', 'right', 'rightBottom', 'bottom', 'leftBottom', 'left'
   */ 
  dragCreateEvents(dNode, dragPosition) {
    let { plate, blockMap, plateObj } = this,
    parent = dNode.parentNode,
    nodeMap = blockMap.get(parent.id)
    
    dNode.addEventListener('mousedown', ev => {
      // 阻止事件冒泡
      let event = ev || window.event
      event.stopPropagation()
      
      let bLayerX = ev.layerX, bLayerY = ev.layerY
      
      plate.onmousemove = e => {
        let {pageX, pageY} = e,
        differX = pageX - bLayerX - plateObj.left, 
        differY = pageY - bLayerY - plateObj.top

        this.handleDragData(dragPosition, differX, differY, nodeMap)

        // 更新视图
        parent.style.left = nodeMap.x + 'px'
        parent.style.top = nodeMap.y + 'px'
        parent.style.width = nodeMap.width + 'px'
        parent.style.height = nodeMap.height + 'px'

        this.fn(this.blockMap)
      }
    })
    dNode.addEventListener('mouseup', () => {
      plate.onmousemove = null
    })
    document.body.addEventListener('mouseup', () => {
      plate.onmousemove = null
    })
  }

  /**
   * 处理8个方向拖拽數据
   * @param {String} dragPosition 'leftTop', 'top', 'rightTop', 'right', 'rightBottom', 'bottom', 'leftBottom', 'left'
   * @param {*} differX 
   * @param {*} differY 
   * @param {*} nodeMap 
   */
  handleDragData(dragPosition, differX, differY, nodeMap) {
    let { plateObj } = this, width, height, min
    switch(dragPosition) {
      case 'leftTop': 
        if(differX < nodeMap.rightBottomCoordinate.x) {
          // 更新方块坐标
          nodeMap.x = differX

          // 限制可移动区域 
          if(differX < 0) nodeMap.x = 0
        }
        if(differY < nodeMap.rightBottomCoordinate.y) {
          nodeMap.y = differY
  
          if(differY < 0) nodeMap.y = 0
        }

        // 更新方块大小
        width = nodeMap.rightBottomCoordinate.x - nodeMap.x
        height = nodeMap.rightBottomCoordinate.y - nodeMap.y
        if(nodeMap.blockType == 'circle') {
          min = Math.min(width, height)
          nodeMap.width = min
          nodeMap.height = min
          nodeMap.x = nodeMap.rightBottomCoordinate.x - min
          nodeMap.y = nodeMap.rightBottomCoordinate.y - min
        } else {
          nodeMap.width = width
          nodeMap.height = height
        }
      break
      case 'top': 
        if(differY < nodeMap.rightBottomCoordinate.y) {
          nodeMap.y = differY

          if(differY < 0) nodeMap.y = 0
        }

        // 更新方块大小
        height = nodeMap.rightBottomCoordinate.y - nodeMap.y
        if(nodeMap.blockType == 'circle') {
          nodeMap.rightBottomCoordinate.x += (height - nodeMap.height) / 2
          
          nodeMap.width = height
          nodeMap.height = height
          nodeMap.x = nodeMap.rightBottomCoordinate.x - height
          nodeMap.y = nodeMap.rightBottomCoordinate.y - height
        } else {
          nodeMap.height = height
        }
      break
      case 'rightTop': 
        if(differY < nodeMap.rightBottomCoordinate.y) {
          // 更新方块坐标
          nodeMap.y = differY
          // 限制可移动区域 
          if(differY < 0) nodeMap.y = 0
        }

        // 更新方块大小
        width = differX - nodeMap.x
        height = nodeMap.rightBottomCoordinate.y - nodeMap.y

        if(nodeMap.blockType == 'circle') {
          min = Math.min(width, height)
          nodeMap.width = min
          nodeMap.height = min
          nodeMap.rightBottomCoordinate.x = nodeMap.x + nodeMap.width
          nodeMap.x = nodeMap.rightBottomCoordinate.x - min
          nodeMap.y = nodeMap.rightBottomCoordinate.y - min
        } else {
          nodeMap.width = width
          nodeMap.height = height
        }
      break
      case 'right': 
        if(nodeMap.rightBottomCoordinate.x > this.plateObj.width) differX = this.plateObj.width

        // 更新方块大小
        width = differX - nodeMap.x
        nodeMap.rightBottomCoordinate.x = nodeMap.x + nodeMap.width
        
        if(nodeMap.blockType == 'circle') {
          nodeMap.rightBottomCoordinate.y += (width - nodeMap.width) / 2

          nodeMap.width = width
          nodeMap.height = width
          nodeMap.y = nodeMap.rightBottomCoordinate.y - width
        } else {
          nodeMap.width = width
        }
      break
      case 'rightBottom': 
        // 更新方块大小
        width = differX - nodeMap.x
        height = differY - nodeMap.y

        if(nodeMap.blockType == 'circle') {
          min = Math.min(width, height)
          nodeMap.width = min
          nodeMap.height = min
          nodeMap.rightBottomCoordinate.x = nodeMap.x + nodeMap.width
          nodeMap.rightBottomCoordinate.y = nodeMap.y + nodeMap.height
        } else {
          nodeMap.width = width
          nodeMap.height = height
          nodeMap.rightBottomCoordinate.x = nodeMap.x + nodeMap.width
          nodeMap.rightBottomCoordinate.y = nodeMap.y + nodeMap.height
        }
      break
      case 'bottom': 
        // 更新方块大小
        height = differY - nodeMap.y
        if(nodeMap.blockType == 'circle') {
          nodeMap.rightBottomCoordinate.x += (height - nodeMap.height) / 2

          nodeMap.width = height
          nodeMap.height = height
          nodeMap.x = nodeMap.rightBottomCoordinate.x - height
        } else {
          nodeMap.height = height
          nodeMap.rightBottomCoordinate.y = nodeMap.y + nodeMap.height
        }
      break
      case 'leftBottom': 
        if(differX < nodeMap.rightBottomCoordinate.x) {
          // 更新方块坐标
          nodeMap.x = differX

          // 限制可移动区域 
          if(differX < 0) nodeMap.x = 0
        }
        if(nodeMap.rightBottomCoordinate.y >= plateObj.height) nodeMap.y = plateObj.height - nodeMap.height

        // 更新方块大小
        width = nodeMap.rightBottomCoordinate.x - nodeMap.x
        height = differY - nodeMap.y
        nodeMap.rightBottomCoordinate.y = nodeMap.y + nodeMap.height
        if(nodeMap.blockType == 'circle') {
          min = Math.min(width, height)
          nodeMap.width = min
          nodeMap.height = min
          nodeMap.x = nodeMap.rightBottomCoordinate.x - min
        } else {
          nodeMap.width = width
          nodeMap.height = height
        }
      break
      case 'left': 
        if(differX < nodeMap.rightBottomCoordinate.x) {
          // 更新方块坐标
          nodeMap.x = differX

          // 限制可移动区域 
          if(differX < 0) nodeMap.x = 0
        }

        // 更新方块大小
        width = nodeMap.rightBottomCoordinate.x - nodeMap.x

        if(nodeMap.blockType == 'circle') {
          nodeMap.rightBottomCoordinate.y += (width - nodeMap.width) / 2

          nodeMap.width = width
          nodeMap.height = width
          nodeMap.y = nodeMap.rightBottomCoordinate.y - width
        } else {
          nodeMap.width = width
        }
      break
    }
  }

  /**
   * 去除当前选中方块的样式
   * @returns 
   */
  removeSelectBlock() {
    if(!this.curBlock) return ;
    document.querySelector(`.${this.blockStyle.selectStyle}`) &&
    document.querySelector(`.${this.blockStyle.selectStyle}`).classList.remove(this.blockStyle.selectStyle)
    this.curBlock = {}
  }

  /**
   * 回调方法
   * @param {Function} fn 
   */
  callback(fn) {
    this.fn = fn
  }

  /**
   * 回显视图
   * @param {Array} map 
   */
  echoBlock(map, callback) {
    let { plate, plateObj: { plateClass } } = this, i = 0,
    blockList = document.querySelectorAll(`${plateClass} .block-style`), j = 0,
    status = ['success', 'error', 'click-style'], k;
    
    // 清空
    while(j < blockList.length) {
      plate.removeChild(blockList[j])
      j ++;
    }

    // 追加
    for(;i < map.length; i++) {
      let {width, height, x, y, uuid, mislead, blockType} = map[i],
      block = document.createElement('div')

      this.blockMap.set(uuid, map[i])
      block.setAttribute('class', 'block-style')
      block.setAttribute('id', uuid)
      block.style = `
        width: ${width}px;
        height: ${height}px;
        top: ${y}px;
        left: ${x}px;
      `

      // 方块類型  circle: 圆形， (null | square): 方形
      if(blockType == 'circle') block.classList.add('block-style-circle')

      // 正确答案
      if (mislead) {
        block.dataset.mislead = 1
        block.classList.add('correct')
      }
      // 标记学生点击行为
      block.dataset.mark = -1
     
      // 绑定事件
      this.blockCreateEvent(block)
      this.blockAddDrag(block)

      // 追加状态节点
      k = 0
      while(k < status.length) {
        let statusNode = document.createElement('div')
        statusNode.setAttribute('class', status[k])

        block.append(statusNode)
        k ++;
      }
      plate.append(block)

      // 回显回调 给派生類中执行相关操作
      callback(block, map[i])
    }
  }

  /**
   * 获取dom在文档中的位置坐标
   * @param {node} e 
   * @returns {object<{left: Number, top: Number}>}
   */
  getNodeOffset(e) {
    function getTop(ev){
      let offset = ev.offsetTop;
      if(ev.offsetParent != null){
        offset += getTop(ev.offsetParent);
      }         
      return offset;
    }
  
    function getLeft(ev){
      let offset = ev.offsetLeft;
      if(ev.offsetParent != null){
        offset += getLeft(ev.offsetParent);
      }         
      return offset;
    }
    
    return {left: getLeft(e), top: getTop(e)}
  }

  /**
   * 查询 plate 存在滚动条的所有父节点
   * @param {node} element (default: document.body) 默认以整个文档为范围进行查询
   */
  findscroller(element = document.body) {
    let that = this
    element.onscroll = () => {
      // 过滤
      if(element.contains(that.plate)){
        let {top, left} = that.getNodeOffset(that.plate)
        that.plateObj.top = top - element.scrollTop
        that.plateObj.left = left - element.scrollLeft
      }
    }
    Array.from(element.children).forEach(its => that.findscroller(its))
  }

  /**
   * 随机id 方块唯一识别id
   * @returns 
   */
  getUuid() {
    return 'math-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

}